"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewBookingDropdown = void 0;
const react_1 = __importDefault(require("react"));
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const configContext_1 = require("../../context/configContext");
const IconAddCircleOutline_1 = require("../icons/IconAddCircleOutline");
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
const NewBookingDropdown = (props) => {
    var _a;
    const config = (0, configContext_1.useConfig)();
    return (react_1.default.createElement(Dropdown_1.default, { className: (_a = props.className) !== null && _a !== void 0 ? _a : "" },
        react_1.default.createElement(Dropdown_1.default.Toggle, { variant: "primary", id: "new-booking" },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(IconAddCircleOutline_1.IconAddCircleOutline, null),
                react_1.default.createElement("span", { className: "d-sm-none" }, " Neu"),
                react_1.default.createElement("span", { className: "d-none d-sm-inline" }, " Neue Buchung"))),
        react_1.default.createElement(Dropdown_1.default.Menu, { alignRight: true }, config.resources.map((resource) => {
            return (react_1.default.createElement(Dropdown_1.default.Item, { key: resource.id, onClick: () => {
                    props.onNewBookingSelected(resource);
                } },
                react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { resource: resource })));
        }))));
};
exports.NewBookingDropdown = NewBookingDropdown;
